import nwApi from '../nwApi'

export default function (param) {
    nwApi.call('analytics',param,()=>{

    })
}